import { ROUTE_LOGIN } from '../routing/constants';

const handleLogout = async (setAuth, navigate) => {
  localStorage.removeItem('accessToken');
  setAuth({});
  navigate(ROUTE_LOGIN);
};

export default handleLogout;
